const blurple = {
  // NOTE: NOT matching with Color Brand > tertiary > blurple(100) > #EEEEFF
  50: '#F5F5FF',
  // background.default
  100: '#F5F5FF',
  // background.default
  200: '#EAEAFC',
  300: '#DFDFF9',
  // NOTE: NOT matching with Color Brand > Secondary > blurple(500) > #5A5AAD
  500: '#B3B3E0',
  // NOTE: Matching with Color Brand > Secondary > blurple(500) > #5A5AAD
  light: '#5A5AAD',
  main: '#313199',
  // Color Text > Tertiary > purple(800)
  dark: '#14143D'
};
export default blurple;